import { render, staticRenderFns } from "./DocumentPage1.vue?vue&type=template&id=026c154a&scoped=true&"
import script from "./DocumentPage1.vue?vue&type=script&lang=js&"
export * from "./DocumentPage1.vue?vue&type=script&lang=js&"
import style0 from "./DocumentPage1.vue?vue&type=style&index=0&id=026c154a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026c154a",
  null
  
)

export default component.exports